import React from "react";
import { useTranslation } from "react-i18next";

export default function ProductTypeCustomItem(props) {
    const { t } = useTranslation();
    const { name_t, onClick, disabled } = props;

    return (
        <button type="button" className="wizard-product-custom-item" onClick={onClick} disabled={disabled === true}>
            <div>{t(name_t)}</div>
        </button>
    );
}
